import { z } from 'zod';
export const abnValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        services: z
            .array(z.object({
            service: z.string(),
            reason: z.string(),
            estimatedCost: z.string(),
        }))
            .optional(),
        language: z.string({ message: 'Please select a language' }),
        serviceOption: z.string({ message: 'Please select an option' }),
        effectiveDate: z.string().min(10, 'Effective date is required'),
        patientSigned: z.literal(true),
    }),
});
